import {BASE_URL,GET, IAM_RIGHTS} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchAllVFusersList = async (requestId) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${IAM_RIGHTS}/filter-rights?type=internal`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };